import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
    <mask
      id="mask0_9399_21146"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_9399_21146)">
      <path
        d="M10.9998 22.9498V20.9498C8.91647 20.7165 7.12897 19.854 5.6373 18.3623C4.14564 16.8706 3.28314 15.0831 3.0498 12.9998H1.0498V10.9998H3.0498C3.28314 8.91647 4.14564 7.12897 5.6373 5.6373C7.12897 4.14564 8.91647 3.28314 10.9998 3.0498V1.0498H12.9998V3.0498C15.0831 3.28314 16.8706 4.14564 18.3623 5.6373C19.854 7.12897 20.7165 8.91647 20.9498 10.9998H22.9498V12.9998H20.9498C20.7165 15.0831 19.854 16.8706 18.3623 18.3623C16.8706 19.854 15.0831 20.7165 12.9998 20.9498V22.9498H10.9998ZM11.9998 18.9998C13.9331 18.9998 15.5831 18.3165 16.9498 16.9498C18.3165 15.5831 18.9998 13.9331 18.9998 11.9998C18.9998 10.0665 18.3165 8.41647 16.9498 7.0498C15.5831 5.68314 13.9331 4.9998 11.9998 4.9998C10.0665 4.9998 8.41647 5.68314 7.0498 7.0498C5.68314 8.41647 4.9998 10.0665 4.9998 11.9998C4.9998 13.9331 5.68314 15.5831 7.0498 16.9498C8.41647 18.3165 10.0665 18.9998 11.9998 18.9998ZM11.9998 15.9998C10.8998 15.9998 9.95814 15.6081 9.1748 14.8248C8.39147 14.0415 7.9998 13.0998 7.9998 11.9998C7.9998 10.8998 8.39147 9.95814 9.1748 9.1748C9.95814 8.39147 10.8998 7.9998 11.9998 7.9998C13.0998 7.9998 14.0415 8.39147 14.8248 9.1748C15.6081 9.95814 15.9998 10.8998 15.9998 11.9998C15.9998 13.0998 15.6081 14.0415 14.8248 14.8248C14.0415 15.6081 13.0998 15.9998 11.9998 15.9998ZM11.9998 13.9998C12.5498 13.9998 13.0206 13.804 13.4123 13.4123C13.804 13.0206 13.9998 12.5498 13.9998 11.9998C13.9998 11.4498 13.804 10.979 13.4123 10.5873C13.0206 10.1956 12.5498 9.9998 11.9998 9.9998C11.4498 9.9998 10.979 10.1956 10.5873 10.5873C10.1956 10.979 9.9998 11.4498 9.9998 11.9998C9.9998 12.5498 10.1956 13.0206 10.5873 13.4123C10.979 13.804 11.4498 13.9998 11.9998 13.9998Z"
        className="fill-[#1C1B1F] dark:fill-white"
      />
    </g>
  </svg>
);

export default Icon;
